import React from 'react'
import ImageSupport from "../../../images/pexels-pixabay-531844.jpg"
import './servicesdetail.css';
export default function Auditetconseil() {
    return (
        <div className='article-page'>

            <div className='fenetrearticle'>
                <img src={ImageSupport} alt="Lorem Ipsum" className='article-image' />
                <div className='article-header'>
                   
                    <h1>Audit et conseil</h1>
                   
                </div>
                <div className='textearticle'>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...
                        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat...
                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur...
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...
                        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat...
                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur...
                    </p>
                    <p>je suis une liste</p>
                    <ul>
                        <li>irure</li>
                        <li>dolor</li>
                        <li>veniam</li>
                    </ul>
                    <p>Une liste avec des numeros</p>
                    <ol>
                        <li>irure</li>
                        <li>dolor</li>
                        <li>veniam</li>
                    </ol>
                    <p>Une liste avec des numeros</p>
                    <ol>
                        <li>irure</li>
                        <li>dolor</li>
                        <li>veniam</li>
                    </ol>
                </div>
            </div>
        </div>
    );
}
